"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PasswordRequirements;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var password_util_1 = require("shared/utils/password.util");
// @ts-ignore
var icon_1 = __importStar(require("stories/icon"));
// @ts-ignore
var flex_container_1 = __importDefault(require("../flex-container"));
// @ts-ignore
var text_1 = __importDefault(require("../text"));
var styles_scss_1 = __importDefault(require("./styles.scss"));
var buildRequirementRow = function (password) { return function (_a) {
    var _b, _c;
    var requirement = _a.requirement, text = _a.text;
    return (react_1.default.createElement(flex_container_1.default, { alignItems: "center" },
        react_1.default.createElement(icon_1.default, { size: 16, className: (0, classnames_1.default)((_b = {},
                _b[styles_scss_1.default.errorIcon] = password.length && !requirement,
                _b[styles_scss_1.default.successIcon] = password.length && requirement,
                _b)), type: password.length && requirement ? icon_1.IconType.checkCircle : icon_1.IconType.xCircle }),
        react_1.default.createElement(text_1.default, { ml: 8, className: (0, classnames_1.default)((_c = {},
                _c[styles_scss_1.default.errorText] = password.length && !requirement,
                _c[styles_scss_1.default.successText] = password.length && requirement,
                _c)) }, text)));
}; };
function PasswordRequirements(_a) {
    var password = _a.password, passwordConfirm = _a.passwordConfirm, className = _a.className, userIsAnyStaff = _a.userIsAnyStaff;
    var requirements = (0, password_util_1.validatePasswordRequirements)(password, userIsAnyStaff);
    var RequirementRow = buildRequirementRow(password);
    return (react_1.default.createElement(flex_container_1.default, { className: className, flexDirection: "column" },
        react_1.default.createElement(RequirementRow, { requirement: requirements[password_util_1.PasswordRequirement.Length], text: "Must be ".concat(password_util_1.MIN_PASSWORD_LENGTH, " characters in length") }),
        userIsAnyStaff && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(RequirementRow, { requirement: requirements[password_util_1.PasswordRequirement.LettersAndNumbers], text: "Must contain letters and numbers" }),
            react_1.default.createElement(RequirementRow, { requirement: requirements[password_util_1.PasswordRequirement.MixedCase], text: "Must contain upper and lower case letters" }),
            react_1.default.createElement(RequirementRow, { requirement: requirements[password_util_1.PasswordRequirement.SpecialCharacters], text: "Must contain a special character" }))),
        passwordConfirm !== undefined && (react_1.default.createElement(RequirementRow, { requirement: password === passwordConfirm, text: "Must match password confirmation" }))));
}
